import { useState, useContext, useDeferredValue, useEffect } from "react";
import styles from "../Applicants/css/display-applicant.module.css";
import { useQuery } from "@tanstack/react-query";
import { FilterDropDown } from "../Applicants/Applicants";
import { AiOutlineSearch as SearchIcon } from "react-icons/ai";
import { IoReload as ReloadIcon } from "react-icons/io5";
import apiCall from "../../../utils/apiCall";
import { CircularProgress, styled } from "@mui/material";
import { AxiosError } from "axios";
import ApplicationTable from "./ApplicationTable";
import { Button, DateFilter } from "../../../ui-components";
import { RouteResponse } from "../../../types/index";
import { FetchAllRoutes, reOrderFetchedData } from "../../../hooks/FetchData";
import { apiRequest, config } from "../../../api";
import fileDownload from "js-file-download";
import { NotificationContext } from "../../../providers/notification";
import { useDebounce } from "../../../hooks/useDebounce";

interface GetAllApplicantResponse {
  TotalSize: number;
  StatusCode: number;
  Message: string;
  Data: GetAllApplicantData[];
}

interface GetAllApplicantData {
  ApplicantId: string;
  FirstName: string;
  LastName: string;
  RouteId: number;
  RouteName: string;
  ApplicationDate: string;
  CategoryType: string;
  Gender: string;
  PhoneNumber: string;
  DateBirth: string;
  MaritalStatusId: number;
  MaritalStatus: string;
  Email: string;
  ResidentialAddress: string;
  ContactAddress: string;
  MembershipNo: string;
  ExamLevel: string;
  Qualification: string;
  State: string;
  ApplicationStatus: string;
  HasAcceptance: boolean;
  StateOrigin: string;
  DateAmitted: string;
}

const statusOptions: any = [
  // { val: 1, name: "All" },
  { val: 1, name: "Registered" },
  { val: 2, name: "Approved" },
  // { val: 3, name: "Rejected" },
  { val: 4, name: "In-Progress" },
  { val: 5, name: "Pending" },
  { val: 5, name: "Declined" },
];

export const option3: any = [
  { val: 1, name: "Application" },
  { val: 2, name: "Membership" },
];

const DisplayAppplications = (props: any) => {
  const [routeId, setRouteId] = useState<number>();
  const [searchData, setSearchData] = useState("");
  const [route, setRoute] = useState("");
  const [d_loading, set_d_loading] = useState<boolean>(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [date, setDate] = useState({ start: "", end: "" });
  const [studentTypeId, setStudentTypeId] = useState<number>();
  const [studentTypeName, setStudentTypeName] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { showNotification } = useContext(NotificationContext);

  const deferredSearchTerm = useDeferredValue(searchData);
  const debouncedSearchTerm = useDebounce(deferredSearchTerm, 500);

  // const { setRouteName } = useContext(ApplicationsContext);

  const { isLoading, data } = FetchAllRoutes();

  const formatDate = (date: string) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${month}-${day}-${year}`;
  };

  const reOrderedAllRoutes = data
    ? reOrderFetchedData((data as RouteResponse)?.Data)
    : [];

  const allRoutes = isLoading
    ? []
    : reOrderedAllRoutes.map((item) => {
        return { name: item?.RouteName, val: item?.RouteId };
      });

  const displayStatusName = (status: string) => {
    let statusName = "";

    switch (status) {
      case "In-Progress":
        //statusName = "Not_Started";       
        statusName = "In_Progress";
        break;
      case "Approved":
        statusName = "Completed";
        break;
         case "Pending":
        statusName = "Pending";
        break;
      // case "Rejected":
      //   statusName = "Rejected";
      //   break;
      case "Registered":
        statusName = "Registered";
        break;
         case "Declined":
        statusName = "Declined";
        break;
        case "In-Progress":
        statusName = "Not_Started";       
        break;
      default:
        statusName = "";
    }

    return statusName;
  };

  const statusName = displayStatusName(selectedStatus);

  const getAllSubmitedApplications =
    async (): Promise<GetAllApplicantResponse> => {
      return (
        await apiCall().get(
          `/Approval/GetAllSubmittedApplicantByRoute?PageNumber=${currentPage}&PageSize=${100}&RouteId=${routeId}&ApprovalStatus=${statusName}&sDate=${formatDate(
            date?.start
          )}&eDate=${formatDate(
            date?.end
          )}&StudentType=${studentTypeId}&search=${debouncedSearchTerm}`
        )
      )?.data;
    };

  const getAllSubmitedApplicationsQuery = useQuery(
    [
      `get-All-Submitted-Applicant ${routeId} ${searchData}`,
      date?.start,
      date?.end,
      selectedStatus,
      studentTypeId,
      currentPage,
      debouncedSearchTerm,
    ],
    getAllSubmitedApplications,
    {
      retry: 0,
      refetchOnWindowFocus: false,
      enabled:
        !!date?.start &&
        !!date?.end &&
        !!selectedStatus 
    }
  );

  useEffect(() => {
    if(debouncedSearchTerm?.trim().length > 0) {
     getAllSubmitedApplicationsQuery.refetch();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm])

  const getAllSubmitedApplicationsData =
    getAllSubmitedApplicationsQuery?.data?.Data;
  const getAllSubmitedApplicationsError =
    getAllSubmitedApplicationsQuery?.error as AxiosError;

  const switchRouteId = (route: { val: number; name: string }) => {
    setRouteId(route?.val);
    // setRouteName(route?.name);
    setRoute(route?.name);
  };

  const handleStudentTypeChange = (type: { val: number; name: string }) => {
    setStudentTypeId(type.val);
    setStudentTypeName(type.name);
  };

  const handleStatus = (status: { val: number; name: string }) => {
    setSelectedStatus(status?.name);
  };

  const filteredData = getAllSubmitedApplicationsData?.filter((x) =>
    Object.values(x)
      ?.join(" ")
      ?.toLowerCase()
      ?.includes(searchData?.toLowerCase())
  );

  const handleDownload = () => {
    set_d_loading(true);
    let body: any = {
      routeId: routeId,
    };

    body = JSON.stringify(body);
    apiRequest(
      `api/Approval/downloadSubmittedApplication?RouteId=${routeId}&ApprovalStatus=${statusName}&sDate=${formatDate(
        date?.start
      )}&eDate=${formatDate(date?.end)}&StudentType=${studentTypeId}`,
      "POST",
      body,
      config,
      true
    )
      .then((data: any) => {
        if (!data?.Message) {
          fileDownload(
            data,
            `Applicantion-Report${Math.floor(Math.random() * 10000) + 1}.xlsx`
          );
          showNotification({
            message: "File downloading...",
            type: "success",
          });
        } else {
          showNotification({
            message: data.Message || "No file to download",
            type: "success",
          });
        }

        set_d_loading(false);
      })
      .catch((error: any) => {
        showNotification({
          message: "Sorry File cannot be downloaded",
          type: "error",
        });
        set_d_loading(false);
      });
  };

  return (
    <div className={styles.container}>
      <div className={styles.filterDiv}>
        <label className={styles.searchForm}>
          <span className={styles.sI}>
            <SearchIcon />
          </span>

          <input
            value={searchData}
            onChange={(e) => setSearchData(e.target.value)}
            type="text"
            placeholder="Search"
          />

          <button className={styles.rBtn} type="submit">
            <ReloadIcon />
          </button>
        </label>

        <FilterDropDown
          onChange={switchRouteId}
          text={route ? route : "Membership Route"}
          bg="#0A3922"
          color="#fff"
          options={allRoutes}
        />

        {routeId === 1 && (
          <FilterDropDown
            onChange={handleStudentTypeChange}
            text={studentTypeName ? studentTypeName : "Student Type"}
            bg="#E2E4E9"
            options={studentType}
          />
        )}

        <DateFilter onChange={setDate} />

        <FilterDropDown
          onChange={handleStatus}
          text={selectedStatus ? selectedStatus : "Status"}
          bg="#E2E4E9"
          options={statusOptions}
        />

        <Button
          onClick={handleDownload}
          children={d_loading ? "Loading..." : "Download Application Report"}
          border="#E2E4E9"
          bg="#0A3922"
          color="#fff"
        />
      </div>
      
      <div>
        {getAllSubmitedApplicationsQuery?.isFetching ? (
          <CircularProgress
            sx={{
              fontSize: "1rem",
              marginInline: "auto",
              display: "block",
              marginBlock: "2rem",
            }}
          />
        ) : getAllSubmitedApplicationsQuery.isError ? (
          <StyledError>{getAllSubmitedApplicationsError?.message}</StyledError>
        ) : filteredData && filteredData?.length > 0 ? (
          <ApplicationTable
            data={
              searchData.length > 0
                ? filteredData
                : getAllSubmitedApplicationsData
            }
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalSize={getAllSubmitedApplicationsQuery?.data?.TotalSize}
          />
        ) : (
          <NoResult>No Results</NoResult>
        )}
      </div>
    </div>
  );
};

export default DisplayAppplications;

const studentType = [
  { name: "Exam", val: 1 },
  { name: "NYSC", val: 2 },
];

const StyledError = styled("p")`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;

const NoResult = styled("div")`
  margin-block-start: 0px;
`;
